import React from "react";
import { View, StyleSheet, Dimensions } from "react-native";
import ManaButton from "./ManaButton";

const { width: WIDTH } = Dimensions.get("window");

export default function BottomButton({ buttonText, onPress, disabled, style }) {
  return (
    <View style={[styles.container]}>
      <ManaButton
        isMainButton
        text={buttonText}
        onPress={onPress}
        disabled={disabled}
        style={[
          {
            maxWidth: 250,
            height: 50,
          },
          style,
        ]}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: WIDTH,
    maxWidth: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: 15,
  },
});
